import { DataProvider as RaDataProvider, fetchUtils } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'
import log from 'loglevel'
import { isNil } from 'lodash/fp'

import apiKeys from './api-keys.json'
const env = process.env['REACT_APP_ENV']
const apiKey = apiKeys[env as keyof typeof apiKeys]
const urls = {
  prd: 'https://b2b-api.terashite.jp/partner-user-rest/v1',
  stg: 'https://b2b-api-stg.terashite.jp/partner-user-rest/v1',
  int: 'https://b2b-api-int.dev.terashite.jp/partner-user-rest/v1',
  dev: 'https://b2b-api.dev.terashite.jp/partner-user-rest/v1',
  exp: 'https://b2b-api-exp.dev.terashite.jp/partner-user-rest/v1'
}
const url = urls[env as keyof typeof urls]

log.setLevel(log.levels.DEBUG)

const fetchJson = (url: string, options: fetchUtils.Options = {}): any => {
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('X-API-Key', apiKey)
  // options.mode = 'no-cors'
  options.headers = customHeaders
  return fetchUtils.fetchJson(url, options)
}

export const DataProvider = (): RaDataProvider => ({
  ...simpleRestProvider(url, fetchJson)
})
